import { connect } from 'react-redux';
import { createStructuredSelector, createSelector } from 'reselect';
import LoveActions from 'actions/LoveActions';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import FrameworkUtils from 'utils/framework';
import LoveListNameSelector from 'selectors/loves/loveListName/loveListNameSelector';
import { myListsSelector } from 'selectors/page/myLists/myListsSelector';
import DeleteListModalEN from 'components/GlobalModals/DeleteListModal/locales/DeleteListModal_en_US';
import DeleteListModalFR from 'components/GlobalModals/DeleteListModal/locales/DeleteListModal_fr_CA';

const { wrapHOC } = FrameworkUtils;
const { getLocalisedDataFromResource, getTextFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(DeleteListModalEN, DeleteListModalFR);
const { loveListNameSelector } = LoveListNameSelector;

const localization = createStructuredSelector({
    deleteList: getTextFromResource(getText, 'deleteList'),
    deleteText: getTextFromResource(getText, 'deleteText'),
    yesDeleteList: getTextFromResource(getText, 'yesDeleteList'),
    noKeepList: getTextFromResource(getText, 'noKeepList'),
    myLists: getTextFromResource(getText, 'myLists'),
    somethingWentWrong: getTextFromResource(getText, 'somethingWentWrong'),
    gotIt: getTextFromResource(getText, 'gotIt')
});

const fields = createSelector(loveListNameSelector, myListsSelector, localization, (loveListName, myLists, textResources) => {
    return {
        loveListName,
        myLists,
        localization: {
            ...textResources
        }
    };
});

const functions = dispatch => ({
    removeSharableList: ({ listId, cbSuccess = () => {}, cbCleanup = () => {} }) => {
        const action = LoveActions.removeSharableList({ listId, cbSuccess, cbCleanup });
        dispatch(action);
    },
    getFlatLoveListSkusOverview: (isUpdateShoppingList, callback, force) => {
        const action = LoveActions.getFlatLoveListSkusOverview(isUpdateShoppingList, callback, force);
        dispatch(action);
    }
});

const withDeleteListModalProps = wrapHOC(connect(fields, functions));

export {
    fields, functions, withDeleteListModalProps
};
